import React from 'react'
import { Component } from 'react';
import './BusinessOfferings.less'
import FeatureListItemUpdated from './FeatureListItemUpdated';

const offerings = [
    'Vetted Customers Requesting Services in Your Area Daily',
    'Dedicated Account Manager to Secure More Business',
    'See Quotes From Other Businesses to Match/Beat Competition',
    'Personalized Dashboard for Quoting/Scheduling Customers',
    'Business Profile Page with Reviews/Photos',
    'Digital Advertising For Your Business'
]
class BusinessOfferings extends Component {
    render() {
        return <div className="business-offerings-container">
            {this.props.hideHeadings ? '' : <><div className="business-offerings-sub-heading">
                Grow Your
            </div>
                <div className="business-offerings-main-heading">
                    Business
            </div>
                <div className='business-offerings-main-heading-bottom' />
                <div className="business-offerings-bottom-heading">
                    On Demand Access To Real-Time Local Customers
            </div></>}
            {this.props.hideFeatures ? '' : <div className='feature-list-container'>
                <div className='feature-list-heading'>Here's What ServiceGrace Offers:</div>
                <div className='feature-list-item-container'>
                    {offerings.map(of => <FeatureListItemUpdated content={of} />)}
                </div>
            </div>}
        </div>
    }
}

export default BusinessOfferings;